import React from "react"
import { FlexContainer } from "../../styled/layout.styled"
import SectionTopic from "../reuseAble/SectionTopic"
import SkillsLinear from "./SkillsLinear"
import styled from "@emotion/styled"

const StyledFlexContainer = styled(FlexContainer)`
  @media only screen and (max-width: 500px) {
    width: 100%;
    padding: 0 0 30px 0;
  }
`

const SkillsList = ({ topic, skillsList }) => {
  return (
    <>
      <StyledFlexContainer FlexWrap="wrap" width="45%" flexDirection="column">
        <SectionTopic topic={topic} />
        {skillsList
          ? skillsList.map(({ id, title, skillsPercent }) => (
              <SkillsLinear
                key={id}
                title={title}
                skillsPercent={skillsPercent}
              />
            ))
          : null}
      </StyledFlexContainer>
    </>
  )
}

export default SkillsList
